import BrandSlider from "../../../components/Brands/Brands";
import NavCategoryPage from "./NavbarCategory";
import { useNavigate } from "react-router-dom";
const CategoryTwo = ({ selectedCategory }) => {
  const navigate = useNavigate();
  return (
    <>
    

      <NavCategoryPage slug={selectedCategory} />

      {/* ✅ HERO BANNER */}
      <div
        style={{
          marginTop: "40px",
          position: "relative",
          width: "100%",
          height: "450px",
          backgroundImage:
            "url('/mens.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          borderRadius: "12px",
          overflow: "hidden",
        }}
      >
        {/* OVERLAY */}
        <div
         
     
        />

        {/* TEXT CONTENT */}
        <div
          style={{
            position: "relative",
            zIndex: 2,
            height: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            paddingLeft: "60px",
            color: "#fff",
            maxWidth: "500px",
          }}
        >
          <h2
            style={{
              fontSize: "40px",
              fontWeight: "700",
              marginBottom: "16px",
              lineHeight: "1.2",
            }}
          >
            Style That Speaks Confidence
          </h2>

          <p
            style={{
              fontSize: "16px",
              lineHeight: "1.7",
              marginBottom: "24px",
              opacity: 0.95,
            }}
          >
            Elevate your everyday wardrobe with modern essentials crafted for comfort and confidence.
          </p>

          <button onClick={() => navigate("/shop")}
            style={{
              width: "fit-content",
              padding: "14px 28px",
              backgroundColor: "#ffffff",
              color: "#000",
              border: "none",
              borderRadius: "8px",
              fontSize: "15px",
              fontWeight: "600",
              cursor: "pointer",
              transition: "0.3s ease",
            }}
          >
            Shop The Collection
          </button>
        </div>
      </div>
      <div>
        <BrandSlider/>
      </div>
    </>
  );
};

export default CategoryTwo;